/**
 * WorkshopOption — one selectable workshop row in the publish-shift picker, with its teacher-presence flag (BON-474).
 *
 * Extracted from PublishShiftDrawer so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
import type { RegionalWorkshopEntry } from './regionalApi';
import { formatShiftStart } from './shiftFormat';

export function WorkshopOption({
  w,
  selected,
  onSelect,
}: {
  w: RegionalWorkshopEntry;
  selected: boolean;
  onSelect: () => void;
}) {
  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '8px 10px',
        borderRadius: 8,
        border: `1px solid ${selected ? 'var(--nb-primary)' : 'var(--nb-border)'}`,
        background: selected ? 'var(--nb-primary-soft)' : 'var(--nb-surface)',
        cursor: 'pointer',
      }}
    >
      <input
        type="radio"
        name="publish-shift-workshop"
        checked={selected}
        onChange={onSelect}
        style={{ accentColor: 'var(--nb-primary)' }}
      />
      <span style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <span style={{ fontSize: 12, fontWeight: 700 }}>
          {w.venueShort ?? w.venueName}
          {w.treeSpecies ? ` · ${w.treeSpecies}` : ''}
        </span>
        <span style={{ fontSize: 11, color: 'var(--nb-muted)' }}>{formatShiftStart(w.date)}</span>
        {/* BON-474: publishing happens before staffing, so say which workshops
            still need their teacher sourced — that's what this drawer is for. */}
        <span
          style={{
            fontSize: 10.5,
            color: w.leadInstructor ? 'var(--nb-subtle)' : 'var(--nb-warn)',
            fontWeight: w.leadInstructor ? 400 : 700,
          }}
        >
          {w.leadInstructor ? `Teacher: ${w.leadInstructor}` : 'No teacher yet'}
        </span>
      </span>
    </label>
  );
}
